export const customLocaleText = {
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorEq: 'Equals',
    headerFilterOperatorNeq: 'Not Equals',
    headerFilterOperatorLt: 'Less Than',
    headerFilterOperatorGt: 'Greater Than',
  };